import { Contents, Step, Steps } from 'types/transactionModal';

export const STATUS_KEY = {
  INITIALIZE_PROXY: 'INITIALIZE_PROXY',
  APPROVE_ALL_ASSETS: 'APPROVE_ALL_ASSETS',
  APPROVE_CURRENCY_PLA: 'APPROVE_CURRENCY_PLA',
  APPROVE_CURRENCY_WETH: 'APPROVE_CURRENCY_WETH',
  APPROVE_CURRENCY_KLAY: 'APPROVE_CURRENCY_KLAY',
  CREATE_ORDER_LISTING: 'CREATE_ORDER_LISTING',
  CREATE_ORDER_MAKE_OFFER: 'CREATE_ORDER_MAKE_OFFER',
  FULFILL_ORDER_OFFER_ACCEPT: 'FULFILL_ORDER_OFFER_ACCEPT',
  FULFILL_ORDER_BUY: 'FULFILL_ORDER_BUY',
  SET_PENDING_TRANSACTION_HASH: 'SET_PENDING_TRANSACTION_HASH',
  TX_FAILED: 'TX_FAILED',
  TRANSFER_ALL: 'TRANSFER_ALL',
  TRANSFER_ONE: 'TRANSFER_ONE',
  WRAP_ETH: 'WRAP_ETH',
};

export const transferContents: Contents = {
  [STATUS_KEY.INITIALIZE_PROXY]: {
    heading: 'Initialize your account',
    body: [
      'Signing this transaction in your wallet will allow you transact on Marketplace.',
      'Please confirm this transaction to proceed. This will incur a one-time gas fee.',
    ],
  },

  [STATUS_KEY.APPROVE_ALL_ASSETS]: {
    heading: 'Unlocking items for trading',
    body: [
      'Signing this transaction in your wallet will allow you to trade this item and any item in the same collection on Marketplace.',
      'Please confirm this transaction to proceed. This will incur a one-time gas fee for this item/collection.',
    ],
  },
  [STATUS_KEY.SET_PENDING_TRANSACTION_HASH]: {
    heading: 'Finalizing',
    body: [
      'Waiting for blockchain confirmation.',
      'The gift will be delivered soon.',
    ],
  },
};

export const contents: Contents = {
  [STATUS_KEY.INITIALIZE_PROXY]: {
    heading: 'Initialize your account',
    body: [
      'Signing this transaction in your wallet will allow you transact on Marketplace.',
      'Please confirm this transaction to proceed. This will incur a one-time gas fee.',
    ],
  },
  [STATUS_KEY.APPROVE_ALL_ASSETS]: {
    heading: 'Unlocking items for trading',
    body: [
      'Signing this transaction in your wallet will allow you to trade this item and any item in the same collection on Marketplace.',
      'Please confirm this transaction to proceed.',
      'This will incur a one-time gas fee for this item/collection.',
    ],
  },
  [STATUS_KEY.APPROVE_CURRENCY_PLA]: {
    heading: 'Approve PLA transaction',
    body: [
      'Signing this transaction in your wallet will approve your wallet to use PLA for transactions on Marketplace.',
      'Please confirm this transaction to proceed.',
      'This will incur a one-time gas fee.',
    ],
  },
  [STATUS_KEY.APPROVE_CURRENCY_WETH]: {
    heading: 'Approve WETH transaction',
    body: [
      'Signing this transaction in your wallet will approve your wallet to use WETH for transactions on Marketplace.',
      'Please confirm this transaction to proceed.',
      'This will incur a one-time gas fee.',
    ],
  },
  [STATUS_KEY.APPROVE_CURRENCY_KLAY]: {
    heading: 'Approve KLAY transaction',
    body: [
      'Signing this transaction in your wallet will approve your wallet to use KLAY for transactions on Marketplace.',
      'Please confirm this transaction to proceed.',
      'This will incur a one-time gas fee.',
    ],
  },
  [STATUS_KEY.CREATE_ORDER_LISTING]: {
    heading: 'Listing',
    body: [
      'Please sign in your wallet to list your item on Marketplace.',
      'This process will not incur a gas fee.',
    ],
  },
  [STATUS_KEY.CREATE_ORDER_MAKE_OFFER]: {
    heading: 'Finalizing',
    body: [
      'Please sign in your wallet to verify your offer to the seller.',
      'This process will not incur a gas fee.',
    ],
  },
  [STATUS_KEY.FULFILL_ORDER_OFFER_ACCEPT]: {
    heading: 'Finalizing',
    body: [
      'Please confirm this smart contract by signing in your wallet to complete your sale.',
      'This process will incur a gas fee.',
    ],
  },
  [STATUS_KEY.FULFILL_ORDER_BUY]: {
    heading: 'Finalizing',
    body: [
      'Please confirm this smart contract by signing in your wallet to purchase this item.',
      'This process will incur a gas fee.',
    ],
  },
  [STATUS_KEY.TRANSFER_ALL]: {
    heading: 'Finalizing',
    body: [
      'Waiting for blockchain confirmation.',
      'The gift will be delivered soon.',
    ],
  },
  [STATUS_KEY.TRANSFER_ONE]: {
    heading: 'Finalizing',
    body: [
      'Waiting for blockchain confirmation.',
      'The gift will be delivered soon.',
    ],
  },
  [STATUS_KEY.WRAP_ETH]: {
    heading: 'Finalizing',
    body: ['Waiting for blockchain confirmation.'],
  },
};

const commonSteps: Step[] = [
  {
    title: 'Initialize',
    icon: 'initialize',
  },
  {
    title: 'Unlock Item',
    icon: 'unlock',
  },
];

export const steps: Steps = {
  eth: [
    ...commonSteps,
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  matic: [
    ...commonSteps,
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  pla: [
    ...commonSteps,
    {
      title: 'Approve PLA',
      icon: 'approve',
    },
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  sol: [
    ...commonSteps,
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  weth: [
    ...commonSteps,
    {
      title: 'Approve WETH',
      icon: 'approve',
    },
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  klay: [
    ...commonSteps,
    {
      title: 'Approve KLAY',
      icon: 'approve',
    },
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  wklay: [
    ...commonSteps,
    {
      title: 'Approve WKLAY',
      icon: 'approve',
    },
    {
      title: 'Listing',
      icon: 'complete',
    },
  ],
  plaAcceptOffer: [
    ...commonSteps,
    {
      title: 'Approve PLA',
      icon: 'approve',
    },
    {
      title: 'Processing',
      icon: 'complete',
    },
  ],
  wethAcceptOffer: [
    ...commonSteps,
    {
      title: 'Approve WETH',
      icon: 'approve',
    },
    {
      title: 'Processing',
      icon: 'complete',
    },
  ],
  plaMakeOffer: [
    {
      title: 'Approve PLA',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  wethMakeOffer: [
    {
      title: 'Approve WETH',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  wklayMakeOffer: [
    {
      title: 'Approve WKLAY',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  solMakeOffer: [
    {
      title: 'Approve SOL',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  transfer: [
    ...commonSteps,
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  plaBuy: [
    {
      title: 'Approve PLA',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  wethBuy: [
    {
      title: 'Approve WETH',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  solBuy: [
    {
      title: 'Approve SOL',
      icon: 'approve',
    },
    {
      title: 'Authorizing',
      icon: 'complete',
    },
  ],
  Buy: [...commonSteps],
};

export default null;
